import { render, staticRenderFns } from "./Combinator.vue?vue&type=template&id=7fc7a1c3&scoped=true&"
import script from "./Combinator.vue?vue&type=script&lang=js&"
export * from "./Combinator.vue?vue&type=script&lang=js&"
import style0 from "./Combinator.vue?vue&type=style&index=0&id=7fc7a1c3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fc7a1c3",
  null
  
)

export default component.exports